<section class="rcx-table">
  <div class="">
    <div class="card shadow-sm border-0 radius-10">
      <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
        <h4 class="mb-0">Notifications</h4>
        <button class="btn btn-sm btn-light text-primary" (click)="markAllAsRead()">Mark All as Read</button>
      </div>
      <div class="card-body p-3">
        <div class="d-flex justify-content-center" *ngIf="isLoading">
          <p class="text-primary mb-0">Fetching notifications, please wait...</p>
        </div>
        <div *ngIf="!isLoading && notifications.length > 0; else noNotificationsTemplate">
          <div *ngFor="let notification of notifications" class="d-flex align-items-center mb-3 p-2 rounded shadow-sm"
            [ngClass]="notification.seen ? 'bg-white cursor-pointer' : 'bg-light cursor-pointer'"
            [routerLink]="parseAction(notification.action).path"
            [queryParams]="parseAction(notification.action).queryParams">
            <div class="me-3">
              <img [src]="getNotificationImage(notification.type)" class="rounded-circle" width="20" height="20"
                alt="{{ notification.type }}" />
            </div>
            <div class="flex-grow-1">
              <p class="mb-0 font-13 text-secondary">{{notification?.message || "Unknown"}}</p>
            </div>
            <div class="ms-3" (click)="markAsSeen(notification.id)">
              <i class="bx large-icon" [ngClass]="!notification.seen ? 'bx-check-circle text-success' : ''"></i>
            </div>

          </div>
        </div>
      </div>
      <ng-template #noNotificationsTemplate>
        <div class="text-center py-5">
          <p class="text-secondary mb-0">No notifications available.</p>
        </div>
      </ng-template>
    </div>
  </div>
</section>